'use client';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './CenterModalContents.module.scss.mjs';

const cx = classNames.bind(styles);
function CenterModalContents(_ref) {
  let {
    title,
    description,
    subText,
    scrollable,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article')
  }, title && /*#__PURE__*/React.createElement("strong", {
    className: cx('title')
  }, title), description && /*#__PURE__*/React.createElement("p", {
    className: cx('description')
  }, description), subText && /*#__PURE__*/React.createElement("div", {
    className: cx('sub-text')
  }, subText), children && /*#__PURE__*/React.createElement("div", {
    className: cx('area', scrollable && `type-scroll`)
  }, children), scrollable && /*#__PURE__*/React.createElement("span", {
    className: cx('gradation')
  }));
}

export { CenterModalContents as default };
